import { Alert, Stack, Text, TextLink } from 'braid-design-system';
import { useCallback, useEffect } from 'react';

import { Link } from 'src/components/Router/Link';
import { EDIT } from 'src/consts';
import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import { useNudgeConfig, type DeprecatedField } from '../utils';

interface TopNudgeProps {
  nudgeType: DeprecatedField;
}

export const TopNudge: React.FC<TopNudgeProps> = ({ nudgeType }) => {
  const nudgeConfig = useNudgeConfig(nudgeType);

  const { alertMessage, alertAutomationNudge, alertAutomationNudgeEditLink } =
    nudgeConfig;
  const { nudgeTracker } = useAnalytics();

  useEffect(() => {
    switch (nudgeType) {
      case 'HOME_LOCATION':
        nudgeTracker({
          eventName: 'nudge_viewed',
          nudgeType: 'home_location',
          callToAction: 'set_home_location',
          callToActionType: 'nudge',
        });
        break;
      case 'PREFERRED_LOCATIONS':
        nudgeTracker({
          eventName: 'nudge_viewed',
          nudgeType: 'preferred_location',
          callToAction: 'set_preferred_location',
          callToActionType: 'nudge',
        });
        break;
      case 'RTW':
        nudgeTracker({
          eventName: 'nudge_viewed',
          nudgeType: 'right_to_work',
          callToAction: 'set_right_to_work',
          callToActionType: 'nudge',
        });
        break;
    }
  }, [nudgeTracker, nudgeType]);

  const onClick = useCallback(() => {
    switch (nudgeType) {
      case 'HOME_LOCATION':
        nudgeTracker({
          eventName: 'nudge_pressed',
          nudgeType: 'home_location',
          callToAction: 'set_home_location',
          callToActionType: 'nudge',
        });
        break;
      case 'PREFERRED_LOCATIONS':
        nudgeTracker({
          eventName: 'nudge_pressed',
          nudgeType: 'preferred_location',
          callToAction: 'set_preferred_location',
          callToActionType: 'nudge',
        });
        break;
      case 'RTW':
        nudgeTracker({
          eventName: 'nudge_pressed',
          nudgeType: 'right_to_work',
          callToAction: 'set_right_to_work',
          callToActionType: 'nudge',
        });
        break;
    }
  }, [nudgeTracker, nudgeType]);

  return (
    <Alert tone="info" data={{ automation: alertAutomationNudge }}>
      <Stack space="large">
        <Text>{alertMessage} </Text>
        <Text>
          <Link
            to={nudgeConfig.linkTo}
            mode={EDIT}
            component={TextLink}
            data={{ automation: alertAutomationNudgeEditLink }}
            onClick={onClick}
          >
            {nudgeConfig.linkTitle}
          </Link>
        </Text>
      </Stack>
    </Alert>
  );
};
